import { TFunction } from "i18next";
import { MetaTagsDto } from "~/application/dtos/seo/MetaTagsDto";

type SiteTags = {
  title: string;
  description: string;
  keywords: string;
  image: string;
  thumbnail: string;
  twitterCreator: string;
  twitterSite: string;
};
export function getDefaultSiteTags(): SiteTags {
  return {
    title: "Never Miss a Critical Update in QuickBooks Again",
    description:
      "Stay informed and in control of your business finances with real-time QuickBooks alerts. Our automated notification system helps you track important financial changes, such as vendor bill increases, price adjustments, and large deposits—so you never miss a critical update. Avoid unexpected financial surprises and make smarter business decisions with ease.",
    keywords: "QuickBooks alerts, QuickBooks automation, Custom QuickBooks notifications, QuickBooks financial monitoring, QuickBooks reporting tool, Automated QuickBooks tracking, QuickBooks vendor bill alerts, QuickBooks invoice tracking, QuickBooks deposit notifications, QuickBooks expense monitoring, QuickBooks SaaS integration, QuickBooks price change alerts, How to set up custom alerts in QuickBooks, Automate QuickBooks financial reporting, Best QuickBooks tools for small businesses, Real-time QuickBooks alerts for vendors and expenses, How to track QuickBooks changes automatically, QuickBooks automation software for businesses",
    image: `https://okzdgdgbxpvjiwxykggo.supabase.co/storage/v1/object/public/public-image//Google%20ad.png`,
    thumbnail: `https://okzdgdgbxpvjiwxykggo.supabase.co/storage/v1/object/public/public-image//Google%20ad.png`,
    twitterCreator: "",
    twitterSite: "",
  };
}

export function defaultSeoMetaTags({ t, slug }: { t: TFunction; slug?: string }): MetaTagsDto {
  const siteTags = getDefaultSiteTags();
  if (slug === "/pricing") {
    siteTags.title = `${t("front.pricing.title")} | ${siteTags.title}`;
    siteTags.description = t("front.pricing.headline");
  } else if (slug === "/blog") {
    siteTags.title = `${t("blog.title")} | ${siteTags.title}`;
    siteTags.description = t("blog.headline");
  } else if (slug === "/contact") {
    siteTags.title = `${t("front.contact.title")} | ${siteTags.title}`;
    siteTags.description = t("front.contact.headline");
  } else if (slug === "/newsletter") {
    siteTags.title = `${t("front.newsletter.title")} | ${siteTags.title}`;
    siteTags.description = t("front.newsletter.headline");
  } else if (slug === "/changelog") {
    siteTags.title = `${t("front.changelog.title")} | ${siteTags.title}`;
    siteTags.description = t("front.changelog.headline");
  }
  return parseMetaTags(siteTags);
}

function parseMetaTags(tags: SiteTags): MetaTagsDto {
  return [
    { title: tags.title },
    { name: "description", content: tags.description },
    { name: "keywords", content: tags.keywords },
    { property: "og:title", content: tags.title },
    { property: "og:type", content: "website" },
    { property: "og:image", content: tags.image },
    { property: "og:card", content: "summary_large_image" },
    { property: "og:description", content: tags.description },
    { property: "twitter:image", content: tags.thumbnail },
    { property: "twitter:card", content: "summary_large_image" },
    { property: "twitter:creator", content: tags.twitterCreator ?? "" },
    { property: "og:creator", content: tags.twitterCreator },
    { property: "twitter:site", content: tags.twitterSite ?? "" },
    { property: "twitter:title", content: tags.title },
    { property: "twitter:description", content: tags.description },
  ];
}
